export default __webpack_public_path__ + "static/media/aster_cien.27812b61.svg";